import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { confirmEmailChange } from '../../../services/user.service';
import { useAuth } from '../../../hooks/use-auth.hook';

export default function ConfirmEmailChangePage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const auth = useAuth();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('Validation du lien de confirmation en cours.');
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        const token = searchParams.get('token') ?? '';
        let redirectTimeout: ReturnType<typeof globalThis.setTimeout> | undefined;

        if ('' === token) {
            setMessage('Le lien de confirmation est invalide.');
            setLoading(false);
            return;
        }

        confirmEmailChange(token)
            .then(response => {
                setMessage(response.status);
                setIsSuccess(true);
                auth.signout();
                redirectTimeout = globalThis.setTimeout(() => {
                    navigate('/');
                }, 2000);
            })
            .catch(error => {
                if (axios.isAxiosError(error) && typeof error.response?.data?.message === 'string') {
                    setMessage(error.response.data.message);
                } else {
                    setMessage("La confirmation de l'adresse email a échoué.");
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            if (undefined !== redirectTimeout) {
                globalThis.clearTimeout(redirectTimeout);
            }
        };
    }, [auth, navigate, searchParams]);

    return (
        <div className="confirmEmailChangePage">
            <Typography variant="h2">Confirmation d&apos;adresse email</Typography>
            {loading ? <CircularProgress sx={{ my: 3 }} /> : null}
            <Typography variant="body1" sx={{ mt: 2, mb: 3 }}>
                {message}
            </Typography>
            <Button component={Link} to="/" variant={isSuccess ? 'contained' : 'outlined'}>
                {isSuccess ? 'Aller à la connexion' : "Retour à l'accueil"}
            </Button>
        </div>
    );
}
